import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from 'react';
import { Picker, } from '../Picker';
const PhotoSelectPicker = ({ children, isLoading, name, onChange, selectionType, value, }) => (_jsx(Picker, Object.assign({ isLoading: isLoading, modifier: "swatch", name: name, onChange: onChange, selectionType: selectionType, value: value }, { children: children })));
const MemoizedPhotoSelectPicker = memo(PhotoSelectPicker);
export { MemoizedPhotoSelectPicker as PhotoSelectPicker };
// MC-1068 Temporary hack for Storybook.
export default PhotoSelectPicker;
